
import SimpleCard from '~/components/blocks/simple-cards/card'
import {mapBlogToSimpleCard} from '~/services/blog'
import {kebabCase} from '~/services/helpers'

export default
	props: item:
		type: Object
		required: true

	components: {
		SimpleCard
	}

	computed:
		blog: -> mapBlogToSimpleCard @item
		classes: -> [
			kebabCase @blog.thumbnailFocalPoint, 'focal-point'
		]

